import { useParams } from 'react-router-dom';

import { useChainId } from '@occc-app/Chain/hooks';
import { getCreatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';
import { OfferConfigurePageContainer } from '@occc-app/offerHelpers/components/OfferConfigurePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';

import { messages } from '../../promocodes.messages';
import { PromocodesConfigurationFormContainer } from '../../components/PromocodesConfiguration';
import { getPromocodesTargetTabProps } from '../../components/PromocodesTargetConfiguration';

export const PromocodesConfigureController = () => {
  const { id: campaignId = '', promocodesId = '' } = useParams<{
    id: string;
    promocodesId: string;
  }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);

  return (
    <OfferConfigurePageContainer
      campaignId={campaignId}
      offerId={promocodesId}
      getBreadcrumbLinks={(offerName) => getCreatePageLinks(campaignId, campaignName, offerName)}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Promocodes}
      ConfigureFormContainer={PromocodesConfigurationFormContainer}
      targetTabProps={getPromocodesTargetTabProps}
    />
  );
};
